import React from "react";
import "./VehicleSearchDialogsStyles.scss";
import {Dialog} from "@material-ui/core";
import {findVehicleGroup, Vehicle, VehicleColour, VehicleGroupNames} from "../../../../../../model/vehicle";
import {ReactSVG} from "react-svg";
import car from "../../../../../../images/car.svg";
import {Button} from "../../../../../../components/Button";
import {strings} from "../../../../../../strings/strings";

interface VehicleSearchSelectDialog {
    open: boolean;
    vehicles: Vehicle[];
    onClose: (event: any) => void;
    onSelect: (vehicle: Vehicle) => void;
    toManualInputListener: () => void;
}

export const VehicleSearchSelectDialog = (props: VehicleSearchSelectDialog) => {
    const {open, vehicles} = props;
    const {onClose, onSelect, toManualInputListener} = props;

    const getVehicleDescription = (vehicle: Vehicle) => {
        return vehicle.constructionYear.toString() + ", " + vehicle.brand
            + ((vehicle.colour && VehicleColour[vehicle.colour]) ? (", " + VehicleColour[vehicle.colour]) : "");
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth={"lg"} disableBackdropClick={true}>
            <div className={"vs-dialog vs-dialog_select"}>
                <div className={"vs-dialog__content fluid"}>
                    <span className={"vs-dialog__content__title"}>{strings.chooseFromSelected}</span>

                    <div className={"vs-dialog__content__vehicles"}>
                        {vehicles.map((value, index) => {
                            return (
                                <div key={index} className={"vs-dialog__content__vehicles__item"}
                                     onClick={() => {
                                         onSelect(value);
                                     }}>
                                    <div className={"vs-dialog__content__vehicles__item__image"}>
                                        <ReactSVG src={car}/>
                                    </div>
                                    <div className={"vs-dialog__content__vehicles__item__type"}>
                                        <span>{VehicleGroupNames[findVehicleGroup(value.vehicleType)]}</span>
                                    </div>
                                    <div className={"vs-dialog__content__vehicles__item__description"}>
                                        <span> {getVehicleDescription(value)}</span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className={"vs-dialog__content__controls"}>
                        <Button label={strings.toolbarManual} onClickListener={toManualInputListener}/>
                    </div>
                </div>
            </div>
        </Dialog>
    )
};